import {Component, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {ActivatedRoute, Router, RouterOutlet} from '@angular/router';

import {HeaderComponent} from "./utils/header/header.component";
import {CalendarComponent} from "./calendar/calendar/calendar.component";
import moment from "moment/moment";
import 'moment-timezone';
import {initFlowbite} from "flowbite";
import { environment } from '../environments/environment';
import {AuthService} from "./services/auth.service";


@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    HeaderComponent,
    CalendarComponent
  ],

  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit{
  title = 'fe-coka-admin';

  day: string = moment().format('YYYY-MM-DD');

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {
    // Set default timezone
    moment.tz.setDefault(environment.timeZone);
  }

  ngOnInit() {
    initFlowbite();
    this.authService.autoAuthUser();
    this.route.params.subscribe(params => {
      this.day = params['day'] ? params['day'] : moment().format('YYYY-MM-DD');
    });
  }

  // Metodo per controllare se l'URL corrente è '/stampa/:day'
  isNoHeaderRoute(): boolean {
    const url = this.router.url;
    return url.startsWith('/stampa/') || url.startsWith('/login') || url.startsWith('/forgot-password') || url.startsWith('/loading') || url.startsWith('/debug-sentry');
  }
}
